import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { requestCanceller } from '../../../service/axiosCancelToken';
import { getAllPlaceCategories } from '../../../service/placeCategoryService';
import { updatePlace } from '../../../service/placeService';
import { placeValidator } from '../../../service/validatorForms';
import ImageUpload from '../../shared/ImageUpload';
import LoadingSpinner from '../../shared/LoadingSpinner';
import './EditPlace.css';
import { getAllArea } from '../../../service/areaService';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';


const EditPlace = () => {

    const { state } = useLocation();
    const { place, placeCategories: allPlaceCategories, areas: allAreas } = state;

    const [title, setTitle] = useState(place.title);
    const [telegram, setTelegram] = useState(place.telegram);
    const [whatsapp, setWhatsapp] = useState(place.whatsapp);
    const [instagram, setInstagram] = useState(place.instagram);
    const [placeCategories, setPlaceCategories] = useState(allPlaceCategories);
    const [placeCategoryName, setPlaceCategoryName] = useState(place.placeCategoryName);
    const [placeCategoryId, setPlaceCategoryId] = useState(place.placeCategoryId);
    const [areas, setAreas] = useState(allAreas);
    const [areaId, setAreaId] = useState(place.areaId);
    const [area, setArea] = useState(place.areaName);
    const [placeInfo, setPlaceInfo] = useState(place.info);
    const [telephone, setTelephone] = useState(place.telephone);
    const [address, setAddress] = useState(place.address);
    const [score, setScore] = useState(place.score);
    const [placeImage, setPlaceImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSpinner, setLoadingSpinner] = useState(false);

    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const resetPreviewRef = useRef(false);

    const validatorRef = useRef(placeValidator());
    const {addToast} = useToasts();
    const history = useHistory();
    
    
    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                let newPlace = new FormData();
                newPlace.append('title', title);
                placeImage && newPlace.append('placeImage', placeImage);
                newPlace.append('placeCategoryId', placeCategoryId);
                newPlace.append('placeCategoryName', placeCategoryName);
                newPlace.append('areaId', areaId);
                newPlace.append('areaName', area);
                newPlace.append('info', placeInfo);
                newPlace.append('address', address);
                newPlace.append('telephone', telephone);
                newPlace.append('telegram', telegram);
                newPlace.append('instagram', instagram);
                newPlace.append('whatsapp', whatsapp);
                newPlace.append('score', score);
                setLoadingSpinner(true);

                const { status } = await updatePlace(place._id, newPlace);
                if (status === 201) {
                    addToast("به روز رسانی با موفقیت انجام شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    setLoadingSpinner(false);

                    validatorRef.current.hideMessageFor("title");
                    validatorRef.current.hideMessageFor("placeCategoryId");
                    validatorRef.current.hideMessageFor("placeCategoryName");
                    validatorRef.current.hideMessageFor("telegram");
                    validatorRef.current.hideMessageFor("area");
                    validatorRef.current.hideMessageFor("vocation");
                    validatorRef.current.hideMessageFor("placeInfo");
                    validatorRef.current.hideMessageFor("discount");
                    validatorRef.current.hideMessageFor("address");
                    validatorRef.current.hideMessageFor("telephone");
                    validatorRef.current.hideMessageFor("instagram");
                    validatorRef.current.hideMessageFor("telegram");
                    validatorRef.current.hideMessageFor("whatsapp");
                    validatorRef.current.hideMessageFor("mobileNumber");
                    validatorRef.current.hideMessageFor("age");
                    validatorRef.current.hideMessageFor("score");
                    validatorRef.current.hideMessageFor("vip");
                    validatorRef.current.hideMessages();
                    forceUpdate()
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("چنین مکانی وجود ندارد", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 422) {
                addToast("اطلاعات را کامل وارد کنید", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if(err.response && err.response.status === 401){
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            setLoadingSpinner(false);
        }
    }

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchCategories = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllPlaceCategories({cancelToken: cancelRequest.signal});
                if(status === 201){
                    setPlaceCategories(data.placeCategories);
                }
                let { status: status2, data: data2 } = await getAllArea({cancelToken: cancelRequest.signal});
                if(status2 === 201){
                    setAreas(data2.areas);
                }
                setIsLoading(false);
            } catch (err) {}
        } 
        fetchCategories();
        return () => {
			cancelRequest.cancel();
        }
    },[]);


    const setPlaceCategoryHandler = (event) => {
        try {
            placeCategories.forEach(category => {
                if(String(category._id) === String(placeCategories[event.target.selectedIndex - 1]._id)){
                    setPlaceCategoryName(category.title);
                    setPlaceCategoryId(category._id)
                }
            })
        } catch (error) {}
    }
    const setAreaHandler = (event) => {
        try {
            areas.forEach(area => {
                if(String(area._id) === String(areas[event.target.selectedIndex - 1]._id)){
                    setArea(area.title);
                    setAreaId(area._id);
                }
            })
        } catch (error) {}
    }

    return ( 
        <React.Fragment>
        {
            isLoading ? 
            <div style={{ height: '70vh' }} className="d-flex">
                <div className="text-center align-self-center mx-auto">
                    <LoadingSpinner />
                </div>
            </div>
            :
            <div className="edit-place-container">
                <header >
                    <h1>ویرایش مکان </h1>
                </header>
                <section>
                    <form onSubmit={submitHandler}>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label htmlFor="title323">
                                عنوان
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="title323"
                                    placeholder="عنوان"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    onBlur={() => {
                                        if (title !== '') {
                                            validatorRef.current.showMessageFor("title");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "title",
                                    title,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6">
                                <label htmlFor="telephone">تلفن</label>
                                <input
                                    type="text"
                                    className="form-control ltr pr-3"
                                    style={{fontFamily: 'FontAwesome'}}
                                    id="telephone"
                                    placeholder= '&#xf095;  09... 0513...'
                                    value={telephone}
                                    onChange={(e) => setTelephone(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (telephone !== '') {
                                            validatorRef.current.showMessageFor("telephone");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "telephone",
                                    telephone,
                                    "required|phone"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="inputState2">محدوده جغرافیایی</label>
                                <select id="inputState2" className="form-control "
                                    onChange={setAreaHandler}
                                >
                                    <option  hidden>{area ? area : 'انتخاب کنید ...'}</option>
                                    {
                                        areas.map(item => (
                                            <option key={item._id}>
                                                {item.title}
                                            </option>
                                        ))
                                    }
                                </select>
                                {validatorRef.current.message(
                                    "area",
                                    area,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="inputState1">دسته بندی</label>
                                <select id="inputState1" className="form-control "
                                    onChange={setPlaceCategoryHandler}
                                >
                                    <option  hidden>{placeCategoryName ? placeCategoryName : 'انتخاب کنید ...'}</option>
                                    {
                                        placeCategories.map((item) => (
                                            <option key={item._id}>
                                                {item.title}
                                            </option>
                                        ))
                                    }
                                </select>
                                {validatorRef.current.message(
                                    "placeCategoryName",
                                    placeCategoryName,
                                    "required"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="time81"> نمره (بین 0 تا 5 )</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="time81"
                                    placeholder="نمره"
                                    value={score}
                                    onChange={(e) => setScore(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onBlur={() => {
                                        if (score !== '') {
                                            validatorRef.current.showMessageFor("score");
                                            forceUpdate();
                                        }
                                    }}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                />
                                {validatorRef.current.message(
                                    "score",
                                    score,
                                    "required|numeric"
                                )}
                            </div>
                        </div>
                        <section >
                            <div className="d-flex flex-wrap justify-content-between">
                                <div className="form-group col-sm-6 align-self-center px-0">
                                    <label htmlFor="exampleFormControlTextarea5">
                                        توضیحات درباره مکان
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea5"
                                        rows="4"
                                        placeholder="در حد چند کلمه توضیح دهید"
                                        value={placeInfo}
                                        name="placeInfo"
                                        aria-describedby="description"
                                        onChange={ e => setPlaceInfo(e.target.value)}
                                        onBlur={() => {
                                            if (placeInfo !== '') {
                                                validatorRef.current.showMessageFor("placeInfo");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "placeInfo",
                                        placeInfo,
                                        "required|min:15"
                                    )}
                                </div>
                                <div className="form-group col-sm-6 align-self-center">
                                    <label htmlFor="exampleFormControlTextarea6">
                                        آدرس
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea6"
                                        rows="4"
                                        placeholder="آدرس"
                                        value={address}
                                        name="address"
                                        aria-describedby="description"
                                        onChange={ e => setAddress(e.target.value)}
                                        onBlur={() => {
                                            if (address !== '') {
                                                validatorRef.current.showMessageFor("address");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "address",
                                        address,
                                        "required|min:15"
                                    )}
                                </div>
                            </div>
                        </section>
                        <div className="form-row">
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="telegram324">لینک تلگرام</label>
                                <input
                                    style={{ direction: "ltr", fontFamily:'Times New Romans' }}
                                    type="text"
                                    className="form-control"
                                    id="telegram324"
                                    placeholder="https://telegram.com"
                                    name="telegram"
                                    value={telegram}
                                    onChange={(e) => setTelegram(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
                                    onBlur={() => {
                                        if (telegram !== '') {
                                            validatorRef.current.showMessageFor("telegram");
                                            forceUpdate();
                                        }
                                    }}
                                />
                                {validatorRef.current.message(
                                    "telegram",
                                    telegram,
                                    "url"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="whatsapp324">لینک واتساپ</label>
                                <input
                                    style={{ direction: "ltr", fontFamily:'Times New Romans' }}
                                    type="text"
                                    className="form-control"
                                    id="whatsapp324"
                                    placeholder="https://whatsapp.com"
                                    name="whatsapp"
                                    value={whatsapp}
                                    onChange={(e) => setWhatsapp(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
                                    onBlur={() => {
                                        if (whatsapp !== '') {
                                            validatorRef.current.showMessageFor("whatsapp");
                                            forceUpdate();
                                        }
                                    }}
                                />
                                {validatorRef.current.message(
                                    "whatsapp",
                                    whatsapp,
                                    "url"
                                )}
                            </div>
                            <div className="form-group col-sm-6 col-md-4">
                                <label htmlFor="instagram324">لینک اینستاگرام</label>
                                <input
                                    style={{ direction: "ltr", fontFamily:'Times New Romans' }}
                                    type="text"
                                    className="form-control"
                                    id="instagram324"
                                    placeholder="https://instagram.com"
                                    name="instagram"
                                    value={instagram}
                                    onChange={(e) => setInstagram(digitsFaToEn(digitsArToEn(e.target.value)))}
                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault()}}
                                    onBlur={() => {
                                        if (instagram !== '') {
                                            validatorRef.current.showMessageFor("instagram");
                                            forceUpdate();
                                        }
                                    }}
                                />
                                {validatorRef.current.message(
                                    "instagram",
                                    instagram,
                                    "url"
                                )}
                            </div>
                        </div>
                        <div className="col-12 col-sm-6  mt-1 form-group mx-auto ">
                                <h5 className="font-weight-bold mt-3">عکس مکان <small> ( کمتر از 200 کیلوبایت )</small></h5>
                                <ImageUpload
                                    id="image_1"
                                    setFinalImage={(src) => {
                                        setPlaceImage(src);
                                        resetPreviewRef.current = false;
                                    }}
                                    editModeImageSrc={place.placeImage}
                                    resetPreview={resetPreviewRef.current}
                                />
                        </div>
                        <div className="text-center mt-4">
                        <button 
                                type="submit"
                                className="btn btn-success mr-1 "
                                style={{ width: "100px" }}
                                disabled={loadingSpinner}
                            >
                                <i 
                                    className={loadingSpinner ? 'spinner-border spinner-border-sm mr-2': ''} 
                                    style={{position:'relative', bottom:'2px'}}
                                ></i>
                                ویرایش
                                
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger "
                                style={{ width: "100px" }}
                                onClick={() => history.replace('/dashboard/places')}
                            >
                                بازگشت
                            </button>
                        </div>
                    </form>
                </section>
            </div>
        }
        </React.Fragment>
     );
}
 
export default EditPlace;